import {TournamentStatus} from '@types';
import {t} from 'i18next';
import dayjs from 'dayjs';

import {useTournamentCountdown} from '@utils/hooks/useTournamentCountdown';
import {useFetchTournamentSummaryQuery} from '@api';
import {isMobile} from 'react-device-detect';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowRight} from '@fortawesome/free-solid-svg-icons';
import {Link} from 'react-router';

const TournamentInfo = () => {
    const {data} = useFetchTournamentSummaryQuery();
    const nextTournament = data?.next;
    const prevTournament = data?.previous;

    const [nextTime] = useTournamentCountdown(nextTournament);

    return (
        <div className="index-home-feature index-home-tournaments">
            <div className="index-home-section-heading">
                <h2>{t('tournaments.tournaments')}</h2>
                <Link
                    to="/tournaments"
                    aria-label={`${t('index.see_all')} ${t('tournaments.tournaments')}`}
                    className="index-home-section-link">
                    {t('index.see_all')}{' '}
                    <FontAwesomeIcon icon={faArrowRight} />
                </Link>
            </div>
            <div className="card index-home-feature-card index-home-tournaments-card">
                <table className="table table-responsive m-0 h-100 rounded-sm">
                    <thead className="visually-hidden">
                        <tr>
                            <th scope="col">{t('tournaments.status')}</th>
                            <th scope="col">{t('common.time')}</th>
                            {!isMobile && (
                                <th scope="col">{t('tournaments.ruleset')}</th>
                            )}
                            <th scope="col">{t('tournaments.entrants')}</th>
                            <th scope="col">{t('tournaments.details')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {nextTournament && (
                            <tr>
                                <td>{t('tournaments.next')}</td>
                                <td className="font-mono">
                                    {nextTime > 0 ? (
                                        <span>
                                            T-
                                            {dayjs
                                                .duration(nextTime, 'seconds')
                                                .format('H:mm:ss')}
                                        </span>
                                    ) : (
                                        t('tournaments.running')
                                    )}
                                </td>
                                {!isMobile && (
                                    <td>
                                        <span>
                                            {t(
                                                `tournaments.rulesets.${nextTournament.ruleset}`
                                            )}
                                        </span>
                                    </td>
                                )}
                                <td>
                                    <span>
                                        {nextTournament.playersCount}{' '}
                                        {t('tournaments.entrants')}
                                    </span>
                                </td>
                                <td>
                                    <button
                                        className="btn btn-sm btn-secondary index-home-table-action"
                                        onClick={() =>
                                            (window.location.href = `/tournaments/${nextTournament.id}/lobby`)
                                        }>
                                        {t('tournaments.details')}
                                    </button>
                                </td>
                            </tr>
                        )}
                        {prevTournament && (
                            <tr>
                                <td>{t('tournaments.previous')}</td>
                                <td>
                                    <Link
                                        to={`/tournaments/${prevTournament.id}/results`}>
                                        #{prevTournament.id}
                                    </Link>
                                    {prevTournament.status ===
                                        TournamentStatus.Running && (
                                        <span>
                                            {' - '}
                                            {t('tournaments.running')}
                                        </span>
                                    )}
                                </td>
                                {!isMobile && (
                                    <td>
                                        <span>
                                            {t(
                                                `tournaments.rulesets.${prevTournament.ruleset}`
                                            )}
                                        </span>
                                    </td>
                                )}
                                <td>
                                    <span>
                                        {prevTournament.playersCount}{' '}
                                        {t('tournaments.entrants')}
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        {t('tournaments.winner')}:{' '}
                                        {prevTournament.winners.length > 0 &&
                                            prevTournament.winners.map(
                                                winner => (
                                                    <Link
                                                        key={winner.id}
                                                        data-testid="tournaments-winner"
                                                        to={`/users/${winner.name}`}>
                                                        {winner.name}
                                                    </Link>
                                                )
                                            )}
                                        {prevTournament.winners.length === 0 &&
                                            t('common.na')}
                                    </span>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TournamentInfo;
